module.exports = __webpack_public_path__ + "media/images/common/fp/icon-field-428b79c42f61c3c2601890634b07f463.svg";